import request from './request.js';
import {
	Toast
} from 'vant';
Toast.setDefaultOptions({
	overlay: true
})

const Util = {
	// 获取url 参数
	getQuery(url) {
		// console.log(url, 'url')
		let res = {};
		// console.log(window.location.href,'window.location.href')
		let u = window.location.href.split("?");
		// console.log(u, 'u')
		let urls = url ? url : (u.length > 1 ? u[1] : "");
		// console.log(urls, 'urls')
		let arr = urls.split("&");

		for (let i = 0; i < arr.length; i++) {
			let j = arr[i].split("=");
			res[j[0]] = j[1];
		}
		return res;
	},
	//验证是否是整数或两位小数
	isIntOrFloat(value) {
		let reg = /(^0|[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
		return reg.test(value)
	},
	//验证是否是整数
	isInt(value) {
		let reg = /^[-\\+]?[\\d]*$/;
		return reg.test(value)
	},
	isTel(value) {
		let reg = /^1[3-9]\d{9}$/
		return reg.test(value)
	},
	clearLocalStorage() {
		localStorage.clear();
	},
	formatDatetime(val, format) {
		var d = val ? new Date(val) : new Date();
		var year = d.getFullYear();
		var month = d.getMonth() + 1;
		var day = d.getDate();
		var hours = d.getHours();
		var min = d.getMinutes();
		var seconds = d.getSeconds();

		if (month < 10) month = '0' + month;
		if (day < 10) day = '0' + day;
		if (hours < 0) hours = '0' + hours;
		if (min < 10) min = '0' + min;
		if (seconds < 10) seconds = '0' + seconds;

		if (format) {
			switch (format) {
				case 'yyyy-MM-dd':
					return (year + '-' + month + '-' + day);
					break;
				default:
					return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
					break;
			}
		} else {
			return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
		}

	},
	blobToDataURL(blob, callback) {
		var reader = new FileReader();
		reader.onload = function(e) {
			callback(e.target.result);
		}
		reader.readAsDataURL(blob);
	},
	/**
	 * desc：base64对象转blob文件对象
	 * @param urlData：数据的base64对象
	 * @param type：类型 png,pdf,doc,mp3等;
	 * @returns {Blob}：Blob文件对象
	 */
	base64ToBlob(urlData, type) {
		let arr = urlData.split(',');
		let array = arr[0].match(/:(.*?);/);
		let mime = (array && array.length > 1 ? array[1] : type) || type;
		// 去掉url的头，并转化为byte
		let bytes = window.atob(arr[1]);
		// 处理异常,将ascii码小于0的转换为大于0
		let ab = new ArrayBuffer(bytes.length);
		// 生成视图（直接针对内存）：8位无符号整数，长度1个字节
		let ia = new Uint8Array(ab);
		for (let i = 0; i < bytes.length; i++) {
			ia[i] = bytes.charCodeAt(i);
		}
		return new Blob([ab], {
			type: mime
		});
	},
	getBase64(file) {
		return new Promise((resolve, reject) => {
			let reader = new FileReader();
			let fileResult = "";
			reader.readAsDataURL(file);
			reader.onload = function() {
				fileResult = reader.result;
				console.log(fileResult)
			};
			reader.onerror = function(error) {
				console.log('error')
				reject(error);
			};
			reader.onloadend = function() {
				console.log('onloadend')
				resolve(fileResult);
			};
		})
	},
	cutString(value, length) {
		if (value.length <= length) {
			return value
		} else {
			return value.substring(0, length) + '...'
		}
	},
	//判断当前是PC还是移动端，返回 true 为PC端，返回 false为移动端
	getClientType() {
		var userAgentInfo = navigator.userAgent;
		var agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
		var flag = true;
		for (var i = 0; i < agents.length; i++) {
			if (userAgentInfo.indexOf(agents[i]) > 0) {
				flag = false;
				break;
			}
		}
		return flag;
	},

	uploadFile(file, index) {
		return new Promise((resolve, reject) => {
			// console.log(file)
			//获得后缀
			let suffix = '';
			if (file.file) {
				suffix = file.file.name.substring(file.file.name.lastIndexOf('.') + 1)
			} else {
				suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
			}
			suffix = suffix.toLowerCase().trim()

			if (suffix == 'jpg' || suffix == 'jpeg' || suffix == 'png' || suffix == 'bmp' || suffix == 'webp' || suffix == 'gif') {
				let name = '';
				name = file.file ? file.file.name : file.name;
				if (name == 'image.png') {
					name = '';
				}
				let data = {
					bucketName: 'lucas-admin',
					path: 'temp',
					fileName: name,
					base64: file.content,
					suffix: suffix
				}

				request.post('admin/uploadfile', {
					data: data,
					loading: true
				}).then(res => {
					res.index = index;
					if (res.data.code == 200) {
						resolve(res)
					} else {
						Toast.fail(res.data.message)
						reject(res)
					}
				})
			} else {
				reject({
					code: -1,
					message: '上传图片格式不正确',
					index: index
				});
			}
		})
	},

	uploadVideo(file, index) {
		return new Promise((resolve, reject) => {
			console.log(file)
			//获得后缀
			let suffix = '';
			if (file.file) {
				suffix = file.file.name.substring(file.file.name.lastIndexOf('.') + 1)
			} else {
				suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
			}
			suffix = suffix.toLowerCase().trim()

			if (suffix == 'mp4' || suffix == 'mpeg' || suffix == 'avi' || suffix == 'wmv') {
				let name = '';
				name = file.file ? file.file.name : file.name;
				if (name == 'image.png') {
					name = '';
				}
				let data = {
					bucketName: 'lucas-admin',
					path: 'temp',
					fileName: name,
					base64: file.content,
					suffix: suffix
				}

				request.post('admin/uploadfile', {
					data: data,
					loading: true
				}).then(res => {
					res.index = index;
					if (res.data.code == 200) {
						resolve(res)
					} else {
						Toast.fail(res.data.message)
						reject(res)
					}
				})
			} else {
				reject({
					code: -1,
					message: '上传图片格式不正确',
					index: index
				});
			}
		})
	},
	//把 content 中的标签替换掉
	replaceContent(content) {
		return content.replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n').replace(/<br\/?>/gi, '\n').replace(/<[^>/]+>/g, '').replace(/(\n)?<\/([^>]+)>/g, '').replace(/\u00a0/g, ' ').replace(/&nbsp;/g, ' ').replace(/<\/?(img)[^>]*>/gi, '').replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "\'").replace(/&quot;/g, "\"").replace(/<\/?.+?>/g, "");
	},
	//获取百度地图实例
	getBMapGl() {
		return new Promise(function(resolve, reject) {
			window.init = function() {
				resolve(BMapGL)
			}
			const script = document.createElement('script')
			script.type = 'text/javascript'
			script.src = `http://api.map.baidu.com/api?v=1.0&type=webgl&ak=cHQPjvS0e7lkQnkaiSmG4vBPNm0Q3NxQ&callback=init`
			script.onerror = reject
			document.head.appendChild(script)
		})
	}
}
export default Util;



// WEBPACK FOOTER //
// ./src/utils/util.js